// libs
import { styled } from '@nykaa/ui-components';
import { BREAKPOINTS } from 'shared/styles/base';

//components
import ButtonBase from '@nykaa/ui-components/Button';
import CircleXDuotoneIcon from '@nykaa/ui-components/Icons/circle-x-duotone';
import { SpotLoader } from '@nykaa/ui-components/Loader';

const Z_INDEX = 3;

export const RemoveButton = styled.div`
  position: absolute;
  right: 4px;
  top: 4px;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: ${Z_INDEX};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    right: 8px;
    top: 8px;
  }
`;

export const ConfirmContainer = styled.div`
  width: 360px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: ${({ theme }) => theme.spacing.spacing100};
  border-radius: ${({ theme }) => theme.borders.radius60};
  background-color: ${({ theme }) => theme.colors.surface};
`;

export const CloseIcon = styled(CircleXDuotoneIcon)`
  cursor: pointer;
`;

export const ConfirmTitle = styled.div`
  text-align: center;
  ${({ theme }) => theme.typography.titleLarge};
`;

export const ConfirmSubtitle = styled.div`
  text-align: center;
  margin-top: ${({ theme }) => theme.spacing.spacing80};
  color: ${({ theme }) => theme.colors.textSecondary};
  ${({ theme }) => theme.typography.bodyMedium};
`;

export const ActionButton = styled(ButtonBase)`
  min-height: 48px;
  margin-top: ${({ theme }) => theme.spacing.spacing160};
  border-radius: ${({ theme }) => theme.borders.radius10};
`;

export const Loader = styled(SpotLoader)`
  border-color: ${({ theme }) => theme.colors.surface};
`;
